import { Fragment } from 'react'

function Panel() {
  return <Fragment>Layers</Fragment>
}

export default Panel
